import { Controller } from '@hotwired/stimulus'
import { Modal } from 'bootstrap'

export default class extends Controller {
  static targets = ['container', 'title', 'body']

  open(event) {
    event.preventDefault()

    if (!this.modal) {
      this.modal = new Modal(this.containerTarget)
    }
    this.titleTarget.innerHTML = event.currentTarget.dataset.title || ''
    if (event.currentTarget.dataset['modalBody']) {
      this.bodyTarget.innerHTML = this.element.querySelector(`#${event.currentTarget.dataset['modalBody']}`).innerHTML
    } else {
      this.bodyTarget.innerHTML = Array.from(event.currentTarget.getElementsByClassName('modal-body')).map((el) => el.innerHTML).join()
    }
    this.modal.show()
  }

  close() {
    this.modal.hide()
  }
}
